import * as i18n from "../i18n.ts";
import * as Locale from "../util/Locale.ts";
import { countries } from "./Countries.ts";
import { digit2, digit3 } from "./DateUtils.ts";
import { OS } from "./os.ts";
import * as Storage from "./Storage.ts";

export const preferredTimezone :Set<string> = new Set();

const lastUsedTimezone :Set<string> = new Set();
(Storage.localGet("timezone.lastused")||"").split(",").forEach(tz => {
  if(!!tz){
    lastUsedTimezone.add(tz)
  }
});

export function rememberUsedTimezone(tz :string){
  lastUsedTimezone.add(tz);
  if(lastUsedTimezone.size>5){
    for(var first of lastUsedTimezone){
      lastUsedTimezone.delete(first);
      break;
    }
  }
  Storage.localSet("timezone.lastused",Array.from(lastUsedTimezone).join(','))
}

export function toZone(date :Date, zone :string) {
  var
    asString = date.toLocaleString('en-gb', { timeZone: zone }),
    asStringIso = asString.substring(6, 10) + '-' + asString.substring(3, 5) + '-' + asString.substring(0, 2)
      + 'T' + asString.substring(12, 20) + '.' + digit3(date.getMilliseconds()) + 'Z',
    zonedDate = new Date(asStringIso),
    offset = zonedDate.getTimezoneOffset();

  return new Date(zonedDate.getTime() + offset * 60000);
}

export function fromZone(date: Date, zone: string) {
  var
    delta = date.getTime() - toZone(date, zone).getTime();

  return new Date(date.getTime() + delta);
}

function potentialBuilder(mainCountryCode :string, countryItem :{country_code:string}) {
  return mainCountryCode === countryItem.country_code ? 1 : 0;
  //return ['AU','PT','IT','BR','NL','ES','GB','BE','FR','DE','US'].indexOf(countryItem.country_code)
}

export function getTimezonesSelect() {
  var
    copiedCountry = countries.concat([]),
    countryCode = navigator.language.substring(navigator.language.indexOf('-') + 1),
    countryFormatter : {of:(key:string)=>string};

  try{
    countryFormatter = new Intl.DisplayNames([Locale.get()], { type: 'region' });
  } catch(e){

  }


  copiedCountry.sort((a, b) => potentialBuilder(countryCode, b) - potentialBuilder(countryCode, a));

  var favoriteTzSet = new Set<string>();
  for(let tz of preferredTimezone){
    favoriteTzSet.add(tz);
  }
  for(var tz of lastUsedTimezone){
    favoriteTzSet.add(tz);
  }
  favoriteTzSet.delete(localTimeZone);
  favoriteTzSet.delete(undefined);


  var preparedTz = Array.from(favoriteTzSet);
  preparedTz.reverse();
  preparedTz = preparedTz.slice(0,5)

  preparedTz.sort((a,b)=>{
    return getTimezoneDisplayName(a).localeCompare(getTimezoneDisplayName(b))
  })
  var favorites = preparedTz.length===0?"":`<optgroup label='${i18n.get('timezone.recent')}'>`+preparedTz.map(tz => {
    return `<option value="${tz}">${getTimezoneDisplayName(tz)}</option>`;
  }).join('')+"</optgroup>";

  var countriesHtml = copiedCountry.map(country => {
    return `<optgroup label="${countryFormatter?countryFormatter.of(country.country_code):country.name}">
      ${country.timezones.map(tz => {
        return `<option value="${tz}">${getTimezoneDisplayName(tz)}</option>`;
    })}
    </optgroup>`;


  }).join('');

  return favorites+countriesHtml;
}
function getTimezoneDisplayName(tz :string){
  var result = UTCDELTA[tz];
  if(result!==undefined) return result;

  var items = [tz.substring(tz.lastIndexOf('/') + 1).replace(/_/g,' ')]
  items.push("("+getOffset(tz)+")")
  if(tz === localTimeZone){
    items.push(" - "+i18n.get('timezone.localtime'))
  }
  return UTCDELTA[tz] = items.join(' ');
}

const
  UTCDELTA :{[tz:string]:string} = {},
  localTimeZone = OS.getTimeZone(),
  utcDay = new Date(new Date().toISOString().substring(0,10)+"T00:00:00.000Z"),
  tz = countries.reduce((prev,next)=>{prev.push(...next.timezones);return prev},new Array<string>()),
  TZ_FILL_INTERVAL = setInterval(()=>{
    for(var i=0;i<40;i++){
      var poped = tz.pop();
      if(poped){
        getOffset(poped)
      }else{
        clearInterval(TZ_FILL_INTERVAL)
        break;
      }
    }
  },250)


function getOffset(tz:string){

  var
    french = utcDay.toLocaleString('fr-fr', { timeZone: tz})

  if(parseInt(french.substring(0,2))==utcDay.getDate()){
    return "UTC+"+french.substring(11,16)
  }else{

    let
      deltaMinute = parseInt(french.substring(14,16)),
      deltaHour = 24 - parseInt(french.substring(11,13))+deltaMinute/60;
    return "UTC-"+digit2(Math.floor(deltaHour))+":"+digit2((60-deltaMinute)%60)
  }
}
